import { apiClient } from '@/shared/services/client'
import type {
  Configuracion,
  ConfiguracionUpdateInput,
  TestConnectionInput,
  TestConnectionResult,
} from '@/modules/bd-unificada/types/configuracion'

const BASE = '/bd-unificada/configuracion'

export async function getConfiguracion(): Promise<Configuracion> {
  const response = await apiClient.get<Configuracion>(`${BASE}/`)
  return response.data
}

export async function guardarConfiguracion(data: ConfiguracionUpdateInput): Promise<Configuracion> {
  const response = await apiClient.put<Configuracion>(`${BASE}/`, data)
  return response.data
}

export async function testConnection(data?: TestConnectionInput): Promise<TestConnectionResult> {
  const response = await apiClient.post<TestConnectionResult>(`${BASE}/test-connection`, data ?? {})
  return response.data
}
